import {HomeAsset} from '../class/home-asset';
import {Asset} from '../class/asset';
import {AssetKind} from '../class/asset-kind.enum';
import {PersonKind} from '../class/person-kind.enum';
import {Person} from '../class/person';
import {environment} from '../../../environments/environment';
import {FileReference} from '../class/file-reference';
import {NbDialogRef, NbDialogService} from '@nebular/theme';
import {LoadingDialogComponent} from '../components/dialog/loading-dialog/loading-dialog.component';
import {SimpleMessageDialogComponent} from '../components/dialog/simple-message-dialog/simple-message-dialog.component';
import { ConfirmMessageDialogComponent } from '../components/dialog/confirm-message-dialog/confirm-message-dialog.component';

export class Util {

  public static openPdf(fileReference: FileReference) {
    const base64 = btoa(JSON.stringify(fileReference));
    const url = environment.backendUrl + '/api/file/' + base64;
    window.open(url, '_blank');
  }

  public static getYearFromMonths(months) {
    return Math.round(this.getCurrentYear() + (months / 12));
  }

  public static getCurrentYear(): number {
    return new Date().getFullYear();
  }

  public static asHomeAsset(asset): HomeAsset {
    return asset;
  }

  public static isHomeAsset(asset: Asset): boolean {
    return asset.kind === AssetKind.HOME;
  }

  public static isOtherAsset(asset: Asset): boolean {
    return asset.kind === AssetKind.OTHER;
  }

  public static isGeneralAsset(asset: Asset): boolean {
    return asset.kind === AssetKind.GENERAL;
  }

  public static stringToDate(stringDateTime: string): Date {
    const ms = Date.parse(stringDateTime);

    // tslint:disable-next-line:radix
    return new Date(parseInt(String(ms)));
  }

  public static getPersonByKind(persons, kind: PersonKind): Person {
    let ret = null;
    if (persons) {
      persons.forEach(person => {
        if (person.kind === kind) {
          ret = person;
        }
      });
    }
    return ret;
  }

  public static floatRound(value): number {
    return Math.fround(value);
  }

  public static intRound(value): number {
    return Math.round(value);
  }

  public static getCover(cover, type: number) {
    if (cover) {
      switch (type) {
        case 0: {
          return cover.coverForDeadCase;
        }
        case 1: {
          return cover.coverForIp;
        }
        case 2: {
          return cover.ipProcapite;
        }
        case 3: {
          return cover.coverForNoSelfSuf;
        }
        case 4: {
          return cover.coverForDreadDisease;
        }
        case 5:
        case 6: {
          return cover.totalRiskValue;
        }
        case 7:
        case 8:
        case 9: {
          return cover;
        }
      }
    }
  }

  static isValidFiscalCode(cf) {
    const regex = /^[A-Za-z]{6}[0-9]{2}[A-Za-z]{1}[0-9]{2}[A-Za-z]{1}[0-9]{3}[A-Za-z]{1}$/;
    return regex.test(cf);
  }

  static showLoadingDialog(dialogService: NbDialogService, bodyMsg: string) {
    return dialogService.open(LoadingDialogComponent, {
      context: {
        msg: bodyMsg,
      }
    });
  }

  static showMessageDialog(dialogService: NbDialogService, dialogTitle: string, dialogMsg: string): NbDialogRef<any> {
    return dialogService.open(SimpleMessageDialogComponent, {
      context: {
        title: dialogTitle,
        msg: dialogMsg,
      }
    });
  }

  static showConfirmDialog(dialogService: NbDialogService,dialogTitle: string, dialogMsg: string): NbDialogRef<any> {
    return dialogService.open(ConfirmMessageDialogComponent, {
      context: {
        title: dialogMsg,
        msg: dialogMsg,
      }
    });
  }

  static assetDescription(assetKind: AssetKind): string {
    switch (assetKind) {
      case AssetKind.HOME:
        return 'Immobile';
      case AssetKind.GENERAL:
        return 'Finanziario';
      case AssetKind.OTHER:
        return 'Altro';
    }
    return '';
  }

  static getBaseUrl(): string {
    const isProduction = environment.production;

    let url = environment.backendUrl;

    if (isProduction) {

      url = window.location.href;

      if (url) {
        const index = url.indexOf('#');

        if (index > 0) {
          url = url.substr(0, index - 1);
        } else {
          //check if last char is /
          const slashIndex = url.lastIndexOf('/');

          if (slashIndex > 0) {
            url = url.substr(0, slashIndex - 1);
          }
        }
      }
    }
    return url;
  }
}
